import { themeVar } from '../tenantTheme';


const baseStyle = {
  textAlign: 'left',
  // The token, not a literal: resolves to var(--chakra-fonts-heading) so a tenant font override
  // applies. `heading.fontFamily` layers on top, so a tenant can give headings a different family
  // from `fonts.heading` (which also drives body-adjacent surfaces) without touching the scale.
  fontFamily: themeVar('heading.fontFamily', 'var(--chakra-fonts-heading)'),
  fontStyle: 'normal',
  fontWeight: themeVar('heading.fontWeight', '600'),
  // Not declared before. All three are inherited properties with no UA rule for <h1>-<h6>, so
  // `inherit` is exactly what they compute to today - a concrete reset would not be.
  letterSpacing: themeVar('heading.letterSpacing', 'inherit'),
  textTransform: themeVar('heading.textTransform', 'inherit'),
  color: themeVar('heading.color', 'inherit'),
};

const variants = {
  h1: {
    fontSize: themeVar('heading.h1.fontSize', '48px'),
    lineHeight: themeVar('heading.h1.lineHeight', '60px'),
    fontWeight: themeVar('heading.h1.fontWeight', '600'),
  },
  h2: {
    fontSize: themeVar('heading.h2.fontSize', '36px'),
    lineHeight: themeVar('heading.h2.lineHeight', '48px'),
    fontWeight: themeVar('heading.h2.fontWeight', '600'),
  },
  h3: {
    fontSize: themeVar('heading.h3.fontSize', '30px'),
    lineHeight: themeVar('heading.h3.lineHeight', '40px'),
    fontWeight: themeVar('heading.h3.fontWeight', '600'),
  },
  h4: {
    fontSize: themeVar('heading.h4.fontSize', '24px'),
    lineHeight: themeVar('heading.h4.lineHeight', '36px'),
    fontWeight: themeVar('heading.h4.fontWeight', '600'),
  },
  h5: {
    fontSize: themeVar('heading.h5.fontSize', '20px'),
    lineHeight: themeVar('heading.h5.lineHeight', '32px'),
    fontWeight: themeVar('heading.h5.fontWeight', '600'),
  },
  h6: {
    fontSize: themeVar('heading.h6.fontSize', '18px'),
    lineHeight: themeVar('heading.h6.lineHeight', '28px'),
    fontWeight: themeVar('heading.h6.fontWeight', '600'),
  },
};

const heading = {
  baseStyle,
  variants,
};

export default heading;
